'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Icon = require('./Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var CogIcon = function CogIcon(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutProperties(_ref, ['fill']);

  return _react2.default.createElement(
    _Icon2.default,
    props,
    _react2.default.createElement(
      'svg',
      { style: { display: 'block' }, width: '100%', height: '100%', viewBox: '0 0 16 16', xmlns: 'http://www.w3.org/2000/svg' },
      _react2.default.createElement('path', { fill: fill, fillRule: 'evenodd', d: 'M12.9 4.5L14.4 3 13 1.6l-1.5 1.5c-.7-.5-1.6-.9-2.5-1V0H7v2.1c-.9.2-1.8.5-2.5 1L3.1 1.6 1.6 3.1l1.5 1.5c-.5.6-.9 1.5-1 2.4H0v2h2.1c.2.9.5 1.8 1 2.5L1.6 13 3 14.4l1.5-1.5c.7.5 1.6.9 2.5 1V16h2v-2.1c.9-.2 1.8-.5 2.5-1l1.5 1.5 1.4-1.4-1.5-1.5c.5-.7.9-1.6 1-2.5H16V7h-2.1c-.1-.9-.5-1.8-1-2.5zM8 11c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3-1.3 3-3 3z' })
    )
  );
};

CogIcon.propTypes = _extends({}, _Icon2.default.propTypes);

CogIcon.defaultProps = _extends({}, _Icon2.default.defaultProps, {
  size: 'small'
});

exports.default = CogIcon;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jb21wb25lbnRzL0NvZ0ljb24uanMiXSwibmFtZXMiOlsiQ29nSWNvbiIsImZpbGwiLCJwcm9wcyIsImRpc3BsYXkiLCJwcm9wVHlwZXMiLCJkZWZhdWx0UHJvcHMiLCJzaXplIl0sIm1hcHBpbmdzIjoiOzs7Ozs7OztBQUFBOzs7O0FBQ0E7Ozs7Ozs7O0FBRUEsSUFBTUEsVUFBVSxTQUFWQSxPQUFVLE9BQXdCO0FBQUEsTUFBckJDLElBQXFCLFFBQXJCQSxJQUFxQjtBQUFBLE1BQVpDLEtBQVk7O0FBQ3RDLFNBQ0U7QUFBQTtBQUFVQSxTQUFWO0FBQ0U7QUFBQTtBQUFBLFFBQUssT0FBTyxFQUFFQyxTQUFTLE9BQVgsRUFBWixFQUFrQyxPQUFNLE1BQXhDLEVBQStDLFFBQU8sTUFBdEQsRUFBNkQsU0FBUSxXQUFyRSxFQUFpRixPQUFNLDRCQUF2RjtBQUNFLDhDQUFNLE1BQU1GLElBQVosRUFBa0IsVUFBUyxTQUEzQixFQUFxQyxHQUFFLHNWQUF2QztBQURGO0FBREYsR0FERjtBQU9ELENBUkQ7O0FBVUFELFFBQVFJLFNBQVIsZ0JBQ0ssZUFBS0EsU0FEVjs7QUFJQUosUUFBUUssWUFBUixnQkFDSyxlQUFLQSxZQURWO0FBRUVDLFFBQU07QUFGUjs7a0JBS2VOLE8iLCJmaWxlIjoiQ29nSWNvbi5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCdcbmltcG9ydCBJY29uIGZyb20gJy4vSWNvbidcblxuY29uc3QgQ29nSWNvbiA9ICh7IGZpbGwsIC4uLnByb3BzIH0pID0+IHtcbiAgcmV0dXJuIChcbiAgICA8SWNvbiB7Li4ucHJvcHN9PlxuICAgICAgPHN2ZyBzdHlsZT17eyBkaXNwbGF5OiAnYmxvY2snIH19IHdpZHRoPScxMDAlJyBoZWlnaHQ9JzEwMCUnIHZpZXdCb3g9JzAgMCAxNiAxNicgeG1sbnM9J2h0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnJz5cbiAgICAgICAgPHBhdGggZmlsbD17ZmlsbH0gZmlsbFJ1bGU9J2V2ZW5vZGQnIGQ9J00xMi45IDQuNUwxNC40IDMgMTMgMS42bC0xLjUgMS41Yy0uNy0uNS0xLjYtLjktMi41LTFWMEg3djIuMWMtLjkuMi0xLjguNS0yLjUgMUwzLjEgMS42IDEuNiAzLjFsMS41IDEuNWMtLjUuNi0uOSAxLjUtMSAyLjRIMHYyaDIuMWMuMi45LjUgMS44IDEgMi41TDEuNiAxMyAzIDE0LjRsMS41LTEuNWMuNy41IDEuNi45IDIuNSAxVjE2aDJ2LTIuMWMuOS0uMiAxLjgtLjUgMi41LTFsMS41IDEuNSAxLjQtMS40LTEuNS0xLjVjLjUtLjcuOS0xLjYgMS0yLjVIMTZWN2gtMi4xYy0uMS0uOS0uNS0xLjgtMS0yLjV6TTggMTFjLTEuNyAwLTMtMS4zLTMtM3MxLjMtMyAzLTMgMyAxLjMgMyAzLTEuMyAzLTMgM3onIC8+XG4gICAgICA8L3N2Zz5cbiAgICA8L0ljb24+XG4gIClcbn1cblxuQ29nSWNvbi5wcm9wVHlwZXMgPSB7XG4gIC4uLkljb24ucHJvcFR5cGVzXG59XG5cbkNvZ0ljb24uZGVmYXVsdFByb3BzID0ge1xuICAuLi5JY29uLmRlZmF1bHRQcm9wcyxcbiAgc2l6ZTogJ3NtYWxsJ1xufVxuXG5leHBvcnQgZGVmYXVsdCBDb2dJY29uXG4iXX0=


//////////////////
// WEBPACK FOOTER
// ../~/@segment/react-ui-library/lib/components/CogIcon.js
// module id = 1121
// module chunks = 0